import { ILoadingOverlayParams } from '@ag-grid-community/core'
import { Box, CircularProgress } from '@mui/material'
import React from 'react'
const CustomLoadingOverlayParams = () => {
  return {
    loadingMessage: 'Please wait...',
  }
}

const CustomLoadingOverlay: React.FC<
  ILoadingOverlayParams & { loadingMessage: string }
> = (props) => {
  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <CircularProgress />
      <Box sx={{ marginLeft: 1 }}>{props?.loadingMessage}</Box>
    </Box>
  )
}

export { CustomLoadingOverlay, CustomLoadingOverlayParams }
